<template>
  <div class="image-upload-modal">
    <el-tabs type="border-card" @tab-click="onTabSelect">
      <el-tab-pane label="Choose a picture">
        <!-- TODO: trigger getPexelsImages on enter -->
        <el-input v-model="pexels_search_query"
          :placeholder="'Search Pexels.com ... ' + searchText"
          clearable
          @keyup.enter.native="getPexelsImages('search')">
          <el-button slot="append" icon="el-icon-search" @click="getPexelsImages('search')">Search</el-button>
        </el-input>
        <br />
        <div v-if="pexels_data && pexels_photos.length > 0" style="height: 300px; width: 100%" ref="pexelsScrollbox" >
          <div class="pexels-scroll-box">
            <div :style="gridStyle" class="card-list">
              <div v-for="photo in pexels_photos" :key="photo.id" class="card-item">
                <img
                  v-lazy="photo.src.landscape"
                  :class="{
                    'pexels-image-preview' : true,
                    'is-selected': value === photo.src.landscape
                    // pexels_selected_picture && pexels_selected_picture.id === photo.id
                  }"
                  @click="selectPexelImage(photo)" >
              </div>
            </div>
            <!--<el-button @click="getPexelsImages('url', pexels_data.prev_page)" v-if="pexels_data.prev_page">Prev page</el-button>-->
            <el-button @click="getPexelsImages('url', pexels_data.next_page)" v-if="pexels_data.next_page">Next page</el-button>
          </div>
        </div>
        <div v-else-if="pexels_loading" class="center-container">
          <p class="no-content" style="margin: 5em auto">
            <i class="el-icon-loading" style="font-size: 30pt"></i><br />
            Loading
          </p>
        </div>
        <div v-else-if="pexels_total_results === 0" class="center-container">
          <p class="no-content" style="margin: 5em auto">
            No results found <!-- for &quot;{{pexels_search_query}}&quot; --> :-(
          </p>
        </div>
      </el-tab-pane>

      <el-tab-pane label="Upload your own">
        <div slot="header">
          <span>Upload via Cloud function:</span>
        </div>
        <div
          v-if="!imageURL"
          @click.prevent="onShowUploadPrompt"
          class="preview-image"
          :style="{}">
          <div>
            {{fileUploading ? 'Uploading...' : 'Click to add picture' }}<br />
            <Spinner v-if="fileUploading" class="p-4" size="large" line-bg-color="#868e96" line-fg-color="transparent" />
          </div>
        </div>
        <div v-else>
          <div class="image-list">
            <img
              :src="imageURL"
              :style="{
                border: imageURL === value ? '2px solid #409EFF' : '2px solid #DCDFE6',
                height: '256px'
              }"
              @click="selectLibraryImage(imageURL)">
          </div>
          <el-button size="small" @click="onRemovePicture" type="danger">remove</el-button>
        </div>
        <input v-show="false" ref="hiddenFileUpload" type="file" size="1" @change="onInputImage" />
      </el-tab-pane>

      <!--<el-tab-pane label="Goalpilot Library">
        <div slot="header">
          <span>Predefined images:</span>
        </div>
        <div class="clearfix">
          <div
            v-for="img in predefinedImageList"
            :key="img.id">
            <img
              :src="img.img"
              :alt="img.name"
              width="150"
              :style="{
                cursor:  'pointer',
                border:  img.img === imageURL ? '2px solid yellow' : '2px solid black',
                margin:  '3px',
                padding: '1px',
                float:   'left'
              }"
              @click="selectLibraryImage(img.img)" />
          </div>
        </div>
      </el-tab-pane>-->

      <!--<el-tab-pane label="by URL" disabled>
        <div slot="header">
          <span>Upload via Url:</span>
        </div>
        <el-form-item>
          <el-col :span="16">
            <el-input v-model="imageURL" autocomplete="off"></el-input>
          </el-col>
          <el-col :span="3">
            <el-button v-on:click="updateGoalFormImage()">Load Image</el-button>
          </el-col>
        </el-form-item>
        <h4>Preview</h4>
        <img :src="imageDisplayURL" width="300" class="preview-image-big" />
      </el-tab-pane>-->

      <!--<el-tab-pane label="Color">
        <ColorSelector
          :selected_color="selected_color"
          @color-select="onSelectColor"
          headline="Select color" />
      </el-tab-pane>-->

    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
// TODO: Recycle this class for commitment images
// import ColorSelector from '@/components/Elements/ColorSelector'
// import oldRealTimeDb from "@/generic_api/firebase/rtdb";
import VueLazyload from 'vue-lazyload'
import storage from "@/generic_api/firebase/storage";
import Spinner from "vue-simple-spinner";

// TODO: bug doppelte auswalh

Vue.use(VueLazyload)

export default {
  props: {
    bucket: { default: 'goal_pics' },
    value: {},
    searchText: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    fileUploading: false,
    predefinedImageList: [],
    imageOption: 'upload',
    imageRaw: null,
    imageURL: null,
    imageDisplayURL: null,
    selected_color: null,
    pexels_search_query: '',
    pexels_data: {},
    pexels_photos: [],
    pexels_page: '',
    pexels_selected_picture: null,
    pexels_total_results: null,
    pexels_loading: false,
  }),
  watch: {
    imageOption(value) {
      if ( value === 'library' ) {
        this.onLoad();
      }
    },
  },
  mounted() {
    // TODO: There is actually an store actions for this! -> fetch_predefined_goals
    // TODO: user store actions

    /*
    oldRealTimeDb
      .ref('predefined_goals')
      .limitToFirst(100)
      .once("value", (snapshot) => {
        let val = snapshot.val();
        if ( !val ) {
          return
        }

        this.predefinedImageList = [];
        Object.keys(val).map(key => {
          this.predefinedImageList.push({ id: key, ...val[key] });
        });
      });
    '*/

    this.updateGoalFormImage( this.value );
  },
  computed: {
    gridStyle() {
      let numberOfColumns = 4
      return {
        gridTemplateColumns: `repeat(${numberOfColumns}, minmax(100px, 1fr))`
      }
    },
  },
  methods: {
    onTabSelect() {
      // Lazy load here
    },

    onSelectColor(value) {
      this.selected_color = value;
      // TODO: Save color
    },

    onInputImage(evt) {
      // TODO: move to store
      // TODO: Geht nicht bei erstem aufruf, wegen goalId

      // console.log("onInputImage", evt);

      if ( this.fileUploading ) {
        return;
      }
      this.fileUploading = true;
      let uniqueImageId = this.$models.example._get_uid(); // Goal ID, Commitment ID, etc?

      let file = evt.target.files[0];
      let imageRef = storage.child( this.bucket + '/' + uniqueImageId );

      imageRef.put(file).then((snapshot) => {
        // console.log("Got snapshot", snapshot)

        snapshot.ref.getDownloadURL().then((url) => {
          // console.log("Got URL", url);
          this.imageURL = url;
          // this.imageDisplayURL = url;
          this.$emit('input', url)
          this.fileUploading = false;
        })
      });
    },

    onRemovePicture() {
      this.imageURL = null;
      // TODO: Also delete picture in cloud storage
    },

    updateGoalFormImage( url ) {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        this.imageRaw = image;
        this.imageDisplayURL = url;
      };
    },

    onShowUploadPrompt() {
      // click hidden file input
      this.$refs.hiddenFileUpload.click()
    },

    selectLibraryImage(imageURL) {
      // this.imageURL = imageURL;
      this.$emit('input', imageURL)
      this.updateGoalFormImage();
    },

    selectPexelImage( photo ) {
      // console.log("selected picture", photo);
      this.pexels_selected_picture = photo;
      this.$emit('input', photo.src.landscape)
      // TODO: Set url
    },

    getPexelsImages(source, url) {
      // TODO: Debounce!!

      let pexelsQuery = ''

      if (source === 'search') {
        this.pexels_photos = []; // !
        pexelsQuery = 'https://api.pexels.com/v1/search?query=' +
                  this.pexels_search_query.replace(" ", "+") +
                  '&per_page=32&page=1'
      } else if  (source === 'url') {
        pexelsQuery = url
      }

      this.pexels_total_results = null;
      this.pexels_loading = true;

      return new Promise((resolve, reject) => {

        // INFO: Check quota with:
        // curl -i -H "Authorization: 563492ad6f9170000100000172ee330295c54306b9879279c876707a" "https://api.pexels.com/v1/photos/1"|grep "x-ratelimit"

        let headers = new Headers({
          'Authorization': '563492ad6f9170000100000172ee330295c54306b9879279c876707a'
        });
        console.log('Pexels url', pexelsQuery)
        fetch(pexelsQuery, {

          method: 'get',
          headers: headers

        }).then((response) => {
          return response.json();

        }).then((data) => {
          console.log("Got data from Pexels", data);

          this.pexels_data = data
          this.pexels_photos = this.pexels_photos.concat(data.photos)
          this.pexels_total_results = this.pexels_data.total_results;
          this.pexels_loading = false;

        }).catch(reject)

      });
    },

    /*handleScrollPexels (event) {
      let scrollboxElement = this.$refs.pexelsScrollbox
      console.log('handleScrollPexels', scrollboxElement, scrollboxElement.scrollTop, scrollboxElement.scrollHeight, scrollboxElement.offsetHeight, scrollboxElement.scrollHeight - scrollboxElement.offsetHeight - 200)

      if (scrollboxElement.scrollTop > scrollboxElement.scrollHeight - scrollboxElement.offsetHeight - 200) {
        console.log('handleScrollPexels scroll')
        if (this.pexels_data.next_page && this.pexels_page !== this.pexels_data.next_page ) {
          this.pexels_page = this.pexels_data.next_page
          this.getPexelsImages('url', this.pexels_data.next_page)
        }
      };
      this.lastScrollTop = scrollboxElement.scrollTop
    },*/
  },
  components: {
    Spinner,
    //ColorSelector
  }
}
</script>

<style>
.image-upload-modal .preview-image-big {
  border: 2px solid black
}
.image-upload-modal .preview-image {
  border: 1px dashed black;
  background-color: #f5f7fa;
  color: #868e96;
  font-weight: 600;
  font-size: 0.875rem;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /*user-select: none;*/
}

.image-upload-modal .pexels-scroll-box {
  overflow-y: auto;
  /* visibility: hidden; */
  font-size: 8pt
}

.image-upload-modal .el-tabs__content {
    overflow: scroll !important;
}

.image-upload-modal .pexels-scroll-box-content,
.image-upload-modal .pexels-scroll-box:hover,
.image-upload-modal .pexels-scroll-box:focus {
  visibility: visible;
}

.pexels-image-preview {
  padding: 5px;
  display: grid;
  width: 100%;
  cursor: pointer;
}

.pexels-image-preview.is-selected {
  border: 3px solid #409EFF;
  padding: 2px;
}
.pexelsScrollbox {
  overflow-y: auto;
  visibility: hidden;
  font-size: 8pt
}

.pexelsScrollbox-content,
.pexelsScrollbox:hover,
.pexelsScrollbox:focus {
  visibility: visible;
}
</style>
